import moment from 'moment'
import { convertToBRL } from '~/utils/formatters'

export const getWhatsappFileMessage = (file) => {
  return `%0a%0aDescrição: ${file.description}%0aApuração / Data de competência: ${moment(file.competency_at).format("MM/YYYY")}%0aVencimento: ${moment(file.due_at).format("DD/MM/YYYY")}%0aValor: ${convertToBRL(file.amount)}%0aLink: ${file.access_url}`
}